import React, { useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import styles from "./Auth.module.css";

import ReactGA from "react-ga";

interface Props {
	email: string;
	password: string;
	onSuccess: () => void;
}
export default function ConfirmAccount({ email, password, onSuccess }: Props) {
	const [errorMessage, setErrorMessage] = useState<string>(null!);

	const [code, setCode] = useState("");
	const [loading, setLoading] = useState(false);

	const [codeResent, setCodeResent] = useState(false);
	useEffect(() => {
		ReactGA.pageview("confirm_account_modal");
	}, []);

	const handleConfirmation = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		setErrorMessage(null!);

		if (code === "") {
			setErrorMessage("Please enter confirmation code");
		} else {
			setLoading(true);
			await Auth.confirmSignUp(email, code)
				.then(() => {
					//    If account is confirmed successful, attempt to sign the user in automatically
					//    with the username and password they entered on the previous modal.
					//    If that fails, redirect them to the login modal
					Auth.signIn(email, password)
						.then((res) => {
							onSuccess();
						})
						.catch(() => {
							setLoading(false);
						});
				})
				.catch(() => {
					setErrorMessage("Verification code is invalid");
					setLoading(false);
				});
		}
	};
	const resendConfirmationCode = async () => {
		setCodeResent(false);
		setLoading(true);
		try {
			await Auth.resendSignUp(email);
			setCodeResent(true);
		} catch (error) {
			setErrorMessage(
				"There was a problem re-sending the confirmation code. If this problem continues to occur, please contact support."
			);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className={styles.formWrapper}>
			<form onSubmit={handleConfirmation}>
				<h3 className="text-body fs-3">CONFIRM YOUR ACCOUNT</h3>

				<p className="text-body text-center">
					We have sent a confirmation code to: <span className="text-primary">{email}</span>.
					<br />
					Please enter your code into the box below to verify your account.
					<br />
					<br />
				</p>

				<div className={styles.inputGroup}>
					<label className="text-body">CONFIRMATION CODE</label>
					<input
						className="text-dark"
						type="text"
						value={code}
						disabled={loading}
						onChange={(e) => setCode(e.target.value)}
						placeholder="Confirmation Code"
					/>
					{errorMessage ? <span className={styles.errorMessage}>{errorMessage}</span> : null}
				</div>

				<button type="submit" className="btn btn-primary w-100" disabled={loading}>
					{loading ? "CONFIRMING ACCOUNT..." : "CONFIRM"}
				</button>

				<span className="text-muted d-flex align-items-center">
					Didn't receive an email? Try checking your junk/spam folders OR{" "}
					<button type="button" className="btn btn-link text-primary m-0 p-0 ms-2" onClick={resendConfirmationCode}>
						resend code
					</button>
					.
				</span>
				{codeResent && <p className={styles.successMessageSmall}>Confirmation code has been sent.</p>}
			</form>
		</div>
	);
}
